export default __webpack_public_path__ + "static/media/save.5c8b6bba.svg";